import * as THREE from 'three'
import { Helper } from '../../../../../classes/helper'

interface SlidingDoorHandleWithLockProps {
  position: [number, number, number]
  rotation?: [number, number, number]
  handleColor?: string
  lockColor?: string
}

export const SlidingDoorHandleWithLock = ({
  position,
  rotation = [0, Helper.convertAngleToRadiant(90), 0],
  handleColor = '#CCCCCC',
  lockColor = '#CCCCCC',
}: SlidingDoorHandleWithLockProps): JSX.Element => {
  const handleHeight = 0.25
  const handleRadius = 0.015
  const handleOffsetZ = 0.03

  const lockHousingWidth = 0.01
  const lockHousingHeight = 0.02
  const lockHousingDepth = 0.01

  const keyholeRadius = 0.007
  const keyholeDepth = 0.025
  const keyholeOffsetY = -0.02

  return (
    <group position={position} rotation={rotation}>
      <mesh position={[0, -handleHeight + 0.05 + lockHousingHeight, 0]}>
        <boxGeometry
          args={[lockHousingWidth, lockHousingHeight, lockHousingDepth]}
        />
        <meshStandardMaterial
          color={lockColor}
          metalness={0.7}
          roughness={0.5}
        />
      </mesh>

      <mesh castShadow position={[0, 0, handleRadius + handleOffsetZ]}>
        <cylinderGeometry
          args={[handleRadius, handleRadius, handleHeight, 32]}
        />
        <meshStandardMaterial
          color={handleColor}
          metalness={0.9}
          roughness={0.3}
        />
      </mesh>

      <mesh
        position={[
          0,
          keyholeOffsetY,
          lockHousingDepth / 2 - keyholeDepth / 2 + 0.001,
        ]}
        rotation={[Math.PI / 2, 0, 0]}
      >
        <cylinderGeometry
          args={[keyholeRadius, keyholeRadius, keyholeDepth, 16]}
        />
        <meshStandardMaterial color="black" metalness={0.1} roughness={0.8} />
      </mesh>

      {[handleHeight / 2 - 0.05, -handleHeight / 2 + 0.05].map((yOffset, i) => (
        <mesh
          key={i}
          castShadow
          position={[
            0,
            yOffset,
            lockHousingDepth / 2 + handleOffsetZ - lockHousingDepth,
          ]}
          rotation={[Math.PI / 2, 0, 0]}
        >
          <cylinderGeometry
            args={[handleRadius * 1.2, handleRadius * 1.2, handleOffsetZ, 16]}
          />
          <meshStandardMaterial
            color={handleColor}
            metalness={0.9}
            roughness={0.3}
          />
        </mesh>
      ))}
    </group>
  )
}
